import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ActiveItemSellButton from './ActiveItemSellButton';
import ActiveItemCancelListing from './ActiveItemCancelListing';
import { useRefreshItems } from 'hooks/useRefreshItems';
import { useSoundPath } from 'hooks/useSoundPath';

const ActiveItemOpenSell = ({is_listed, id}) => {
  const refreshItems = useRefreshItems();
  const navigate = useNavigate();
  const playSound = useSoundPath();

  const handleMouseDown = (event) => {
    if (event.button === 1 || event.button === 2) {
      refreshItems();
      window.open(`/inventory/card-pack-open/${id}`)
    }
  };

  const handleClick = (event) => {
    if (event.button === 0) {
      event.preventDefault();
      playSound('main');
      refreshItems();
      setTimeout(() => {
        navigate(`/inventory/card-pack-open/${id}`);
      }, 0);
    }
  };

  return (
    <div className="card-details__buttons">
      <Link
        to={`/inventory/card-pack-open/${id}`}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
        className="card-details__button card-details__button--open"
      >
        Open
      </Link>
      {is_listed ? <ActiveItemCancelListing /> : <ActiveItemSellButton />}
    </div>
  );
};

export default ActiveItemOpenSell;
